require.register("app/restaurant/analyse/product/TempCreateModal", function(exports, require, module){
  $0
  
});

